import { type Meta } from '../types/docs';
import { ONBOARDING_ANALYTICS_CATEGORY_META_PARAM } from './onboardingAnalytics';

const META: Meta = {
  description: 'Event sent when a user completes the onboarding upload step',
  name: 'completed_onboarding_upload',
  params: [ONBOARDING_ANALYTICS_CATEGORY_META_PARAM],
};

export default META;
